"use client";
import { JSX, ReactNode, useState } from "react";
import EmblaSlider from "@/app/components/lib/Embla-slider";
import { TSlideWidith } from "@/app/components/lib/Embla-slider/EmblaSliderContainer";
import useInteractionStart from "@/hooks/useInteractionStart";

interface Props {
  children: ReactNode[];
  ratio: number;
}

const SliderCarousel: React.FC<Props> = ({ children }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const { isInteracting } = useInteractionStart();
  const firstElement = children?.[0];
  const slides = (
    isInteracting ? children : [firstElement]
  ) as Array<JSX.Element>;
  return (
    <div style={{ position: "relative" }}>
      <EmblaSlider
        selectedIndex={currentSlide}
        setSelectedIndex={setCurrentSlide}
        autoPlay={isInteracting}
      >
        <EmblaSlider.EmblaSliderViewport>
          <EmblaSlider.EmblaSliderContainer
            gap={0}
            slides={[
              ...slides?.map((child, key) => ({
                component: <div key={key}>{child}</div>,
                width: "100%" as TSlideWidith,
              })),
            ]}
          />
        </EmblaSlider.EmblaSliderViewport>
      </EmblaSlider>
      {children.length > 1 && (
        <div
          className="dots"
          style={{
            position: "absolute",
            bottom: 10,
            width: "100%",
          }}
        >
          {[
            ...children?.map((_, i) => (
              <span
                key={i}
                className={`dot ${currentSlide === i ? "active" : ""}`}
                onClick={() => setCurrentSlide(i === 0 ? -1 : i)}
              />
            )),
          ]}
        </div>
      )}
    </div>
  );
};
export default SliderCarousel;
